module.exports = __webpack_public_path__ + "media/images/ohap_assignment_close-12e6f5bc81d3c103132385375c7cc279.png";